import { FC, PropsWithChildren } from 'react'
import { cn } from '../../utils/cn'

interface CardHeaderProps {
  className?: string
}

export const CardHeader: FC<PropsWithChildren<CardHeaderProps>> = ({
  children,
  className
}) => (
  <footer
    className={cn(
      'rounded-t-lg bg-blue-50 px-4 py-3 text-sm font-light leading-none text-slate-950',
      className
    )}>
    {children}
  </footer>
)
